import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { generalStore } from '../../store';
import { useTranslation } from 'react-i18next';

import Accordion from '../accordion/Accordion';
import Loader from '../loader/Loader';

import { RESPONSE } from '../../js/_constants';

import './FaqsList.scss';

type Faqs = {
  '@id': string;
  answer: string;
  category: string;
  enabled: boolean;
  position: number;
  question: string;
  language: string;
};

const FaqsList = () => {
  const { getFAQs, faqs } = generalStore();
  const [isLoading, setIsLoading] = useState(true);
  const [faqList, setFaqList] = useState<Faqs[]>([]);
  const { t, i18n } = useTranslation();

  const compare = (a, b) => {
    if (a.position < b.position) {
      return -1;
    }
    if (a.position > b.position) {
      return 1;
    }
    return 0;
  };

  useEffect(() => {
    setIsLoading(true);
  }, []);

  useEffect(() => {
    setFaqList(faqs.sort(compare).filter(faq => faq.enabled));
    setIsLoading(false);
  }, [faqs]);

  useEffect(() => {
    setIsLoading(true);
    getFAQs(i18n.language);
  }, [i18n.language]);

  return (
    <div className="b-faqs-list">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <p>
            {t('faqs_description1')}
            <br />
            {t('faqs_description2')}
          </p>
          <h5>{t('faqs_faqs')}</h5>
          {faqList.map((entry,i) => (
            <Accordion name={`faq-question-${i + 1}`} title={entry.question} key={entry[RESPONSE.ID]}>
              {
                <ul data-testId={`faq-answer-${i + 1}`} >
                  {entry.answer.split('/').map((answer) => (
                    <li key={uuidv4()}>{answer}</li>
                  ))}
                </ul>
              }
            </Accordion>
          ))}
        </>
      )}
    </div>
  );
};

export default FaqsList;
